import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { CaretDown } from "@phosphor-icons/react";
import {
  BreadcrumbItem,
  BreadcrumbPage,
  Button,
  DropdownMenu,
  DropdownMenuTrigger,
} from "@hulahoop/ui";

export function ShellRecordCrumb({ record, menu }: { record: string; menu?: ReactNode }) {
  const { t } = useTranslation();
  if (!menu) {
    return (
      <BreadcrumbItem>
        <BreadcrumbPage>{record}</BreadcrumbPage>
      </BreadcrumbItem>
    );
  }
  return (
    <BreadcrumbItem>
      <DropdownMenu>
        <DropdownMenuTrigger
          render={
            <Button
              variant="ghost"
              size="sm"
              className="-mx-2.5 gap-1 font-semibold text-foreground"
              aria-label={t("shell.switch_record", { record })}
            />
          }
        >
          {record}
          <CaretDown className="text-muted-foreground" />
        </DropdownMenuTrigger>
        {menu}
      </DropdownMenu>
    </BreadcrumbItem>
  );
}
